// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"138":"fd62c235","605":"d4781650","622":"095127e2"}[chunkId] + ".chunk.js";
};